import React from 'react';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import DeclinedPopup from 'src/pages/ServiceRequest/Popup';

export interface DeclinedPopupSubmitData {
  reason: string;
  description: string;
}

export interface PropertyServiceRequestsDeclineModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string, reasonType: string) => void;
}

const PropertyServiceRequestsDeclineModal = ({
  isOpen,
  onClose,
  onConfirm,
}: PropertyServiceRequestsDeclineModalProps) => {
  const handleSubmitPopup = (
    type: 'cancel' | 'submit',
    data?: DeclinedPopupSubmitData
  ): void => {
    if (type === 'cancel' || !data) {
      onClose();
      return;
    }

    onConfirm(data.description, data.reason);
  };

  return (
    <GenericDialogue
      isOpen={isOpen}
      onClose={onClose}
      title="Decline Service Requests"
      maxWidth="60rem"
    >
      <DeclinedPopup onSubmitPopup={handleSubmitPopup} />
    </GenericDialogue>
  );
};

export default PropertyServiceRequestsDeclineModal;
